// src/DownloadApp.jsx
import React, { useState } from 'react';
import {
  FaCheckCircle,
  FaBell,
  FaWifi,
  FaDumbbell,
  FaAppleAlt,
} from 'react-icons/fa';

export default function DownloadApp() {
  const [dark, setDark] = useState(true);
  const bazaarUrl = 'https://cafebazaar.ir/app/ir.mogym.app';

  return (
    <div
      dir="rtl"
      className={`${dark ? 'dark ' : ''}bg-white dark:bg-[#0e1015] text-black dark:text-white font-vazir min-h-screen flex flex-col`}
    >
      {/* هدر */}
      <header className="w-full flex flex-row-reverse items-center justify-between px-6 py-4 shadow-md bg-white dark:bg-[#1a1d2e] sticky top-0 z-30">
        {/* لوگو + نام برند سمت راست */}
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="Mogym Logo" className="h-8" />
          {/* <span className="font-bold text-lg text-gray-900 dark:text-white">
            موجیم
          </span> */}
        </div>

        {/* دکمه‌ها سمت چپ */}
        <div className="flex items-center gap-3">
          <a
            href="/"
            className="px-3 py-2 text-sm rounded-xl border border-gray-300 dark:text-white dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-[#111827]"
          >
            نسخه وب
          </a>

          {/* سوییچ دارک/لایت */}
          <button
            type="button"
            onClick={() => setDark((v) => !v)}
            className="w-10 h-10 rounded-full border border-gray-300 dark:border-gray-600 flex items-center justify-center bg-gray-100 dark:bg-[#111827] text-lg"
            aria-label="تغییر تم"
          >
            {dark ? '☀️' : '🌙'}
          </button>
        </div>
      </header>

      {/* بدنه */}
      <main className="flex-1">
        {/* Hero */}
        <section className="px-4 md:px-10 py-10 md:py-16 bg-gray-50 dark:bg-[#0e1015]">
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
            {/* متن */}
            <div className="text-right">
              {/* <p className="text-sm text-purple-500 font-semibold mb-2">
                اپلیکیشن موجیم
              </p> */}

              <h1 className="text-3xl md:text-4xl font-extrabold mb-4 leading-relaxed text-gray-900 dark:text-white">
                موجیم؛ مربی هوشمند شخصی همیشه همراهت 
              </h1>

              <p className="text-gray-600 dark:text-gray-300 mb-6 text-sm md:text-base leading-7">
                برنامه تمرین و تغذیه ۱۰۰٪ اختصاصی بر اساس بدن، هدف، سبک زندگی و
                تجهیزات تو. بدون نیاز به مربی حضوری. همیشه در دسترس. حتی بدون
                اینترنت.
              </p>

              <p className="text-gray-600 dark:text-gray-300 mb-6 text-sm md:text-base leading-7">
                با موجیم، مسیر رسیدن به تناسب اندام هیچ‌وقت مبهم نیست. هوش مصنوعی
                ما برنامه‌ای می‌سازد که دقیقاً مطابق{' '}
                <span className="font-semibold">
                  توان بدنی، هدف، سابقه تمرینی،
                </span>{' '}
                محدودیت‌ها و شرایط زندگی تو باشد. حرکات با ویدئوی آموزشی دقیق
                ارائه می‌شوند و برنامه پس از یک‌بار دریافت، کاملاً{' '}
                <span className="font-semibold">آفلاین</span> قابل استفاده است.
              </p>

              {/* مزیت‌های کوتاه */}
              <div className="space-y-2 mb-6 text-sm md:text-base text-right">
                <FeatureLine
                  icon={<FaCheckCircle />}
                  text="برنامه تمرین و تغذیه ۱۰۰٪ شخصی‌سازی‌شده با هوش مصنوعی"
                />
                <FeatureLine
                  icon={<FaDumbbell />}
                  text="نمایش تکنیک صحیح حرکات با ویدئوهای دقیق و قابل استفاده در حالت آفلاین"
                />
                <FeatureLine
                  icon={<FaAppleAlt />}
                  text="رژیم‌های سازگار با سبک زندگی ایرانی، با گزینه‌های جایگزین متنوع"
                />
                <FeatureLine
                  icon={<FaBell />}
                  text="یادآور هوشمند تمرین و تغذیه برای اینکه از مسیر خارج نشی"
                />
                <FeatureLine
                  icon={<FaWifi />}
                  text="امکان استفاده کامل از برنامه بعد از یک‌بار دریافت، حتی بدون اینترنت"
                />
              </div>

              {/* دکمه‌ها */}
              <div className="flex flex-col sm:flex-row-reverse gap-3 sm:gap-4 sm:justify-start">
                <a
                  href={bazaarUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-2xl text-sm md:text-base font-semibold shadow-lg transition"
                >
                  نصب از کافه‌بازار — شروع مسیر جدید تو
                </a>

                <a
                  href="/"
                  className="inline-flex items-center justify-center gap-2 border border-gray-300 dark:border-gray-600 px-6 py-3 rounded-2xl text-sm md:text-base text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-[#1f2933] transition"
                >
                  ادامه در نسخه وب
                </a>
              </div>

              <p className="text-xs text-gray-500 dark:text-gray-400 mt-3">
                * ۱ دقیقه طول می‌کشد. هدف امروزت را وارد کن؛ بقیه کارها را موجیم
                انجام می‌دهد.
              </p>
            </div>

            {/* ماکاپ موبایل */}
            <div className="flex justify-center md:justify-start">
              <div className="relative w-64 h-64 md:w-80 md:h-80">
                <div className="absolute -top-8 -right-4 w-32 h-32 rounded-full bg-purple-500/20 blur-2xl" />
                <div className="absolute -bottom-10 -left-6 w-32 h-32 rounded-full bg-pink-500/20 blur-2xl" />

                <div className="relative w-full h-full rounded-[40px] bg-[#070a0f] border-4 border-gray-900 shadow-2xl overflow-hidden flex flex-col">
                  <div className="h-6 flex items-center justify-center">
                    <div className="w-24 h-4 bg-black/60 rounded-full" />
                  </div>

                  <div className="flex-1 bg-gradient-to-b from-[#0f172a] to-[#020617] px-4 py-4 flex flex-col">
                    <div className="flex flex-row-reverse items-center justify-between mb-4">
                      <span className="text-xs text-gray-300 font-vazir">
                        موجیم
                      </span>
                      <span className="text-[10px] text-gray-500">
                        باشگاهی به وسعت ایران
                      </span>
                    </div>

                    <div className="mt-2 mb-5 text-right">
                      <p className="text-xs text-purple-300 mb-1">
                        برنامه امروز
                      </p>
                      <p className="text-sm text-gray-100 font-vazir">
                        تمرین سینه و سرشانه + تغذیه روز سوم
                      </p>
                    </div>

                    <div className="space-y-3 text-xs text-gray-200">
                      <MobileCard
                        title="تمرین"
                        desc="۶ حرکت، ۳ سوپرست، سطح متوسط"
                      />
                      <MobileCard
                        title="تغذیه"
                        desc="۵ وعده، قابل جایگزینی، پر پروتئین"
                      />
                      <MobileCard
                        title="پیشرفت"
                        desc="وزن: ۷۴ → ۷۱.۵ کیلو در ۳ هفته"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* چرا موجیم؟ */}
<section className="px-4 md:px-10 py-10 md:py-14 bg-white dark:bg-[#0b0f19] border-t border-gray-200 dark:border-gray-800">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900 dark:text-white">
      چرا موجیم از مربی حضوری دقیق‌تر، ارزان‌تر و قابل‌اعتمادتر است؟
    </h2>

    <p className="text-sm md:text-base text-gray-600 dark:text-gray-300 mb-8 leading-7 max-w-3xl mx-auto">
      موجیم از اطلاعات بدنی و سبک زندگی تو استفاده می‌کند تا یک برنامه
      <span className="font-semibold"> کاملاً شخصی و علمی </span>
      طراحی کند. این برنامه‌ها نه قالب آماده‌اند، نه حدسی؛ بلکه نتیجه تحلیل
      <span className="font-semibold"> ده‌ها شاخص بدنی و تمرینی با استفاده از هوش مصنوعی </span>
      است. نتیجه؟ برنامه‌ای که دقیقاً برای تو نوشته شده—نه نسخه کپی‌شده از دیگران.
    </p>

    <div className="grid md:grid-cols-3 gap-6 mt-8 text-right md:text-center">
      <FeatureCard
        title="برنامه‌ریزی علمی با هوش مصنوعی"
        body="موجیم با تحلیل سن، قد، وزن، هدف، سطح تمرین، محدودیت‌ها و تجهیزاتت بهترین مسیر رسیدن به نتیجه را برای تو می‌سازد. هر برنامه منحصربه‌فرد است."
      />
      <FeatureCard
        title="تمرین + تغذیه + مکمل در یک اپ"
        body="به‌جای چند مربی و چند اپلیکیشن، موجیم یک برنامه واحد و منسجم برای تمرین، تغذیه، میان‌وعده‌ها و در صورت نیاز پیشنهاد مکمل‌ها ارائه می‌دهد."
      />
      <FeatureCard
        title="همراه همیشه در جیب تو"
        body="بعد از یک‌بار دریافت برنامه، تمام تمرین‌ها، توضیحات و ویدئوها به‌صورت آفلاین قابل مشاهده‌اند. حتی بدون اینترنت هم تمرینت متوقف نمی‌شود."
      />
    </div>
  </div>
</section>


        {/* مقایسه و نحوه شروع */}
        <section className="px-4 md:px-10 py-10 md:py-14 bg-gray-50 dark:bg-[#020617] border-t border-gray-200 dark:border-gray-800">
          <div className="max-w-4xl mx-auto text-right">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900 dark:text-white">
              موجیم یا مربی حضوری؟ انتخاب هوشمندانه مشخص است.
            </h2>

            <ul className="space-y-3 text-sm md:text-base text-gray-700 dark:text-gray-200 mb-8">
              <li>
                🔸 مربی حضوری → معمولاً برنامه عمومی
                <br />
                🔹 موجیم → برنامه ۱۰۰٪ شخصی‌سازی‌شده مخصوص بدن تو
              </li>
              <li>
                🔸 مربی حضوری → فقط در باشگاه در دسترس
                <br />
                🔹 موجیم → ۲۴ ساعته در گوشی تو، همیشه و همه جا
              </li>
              <li>
                🔸 مربی حضوری → هزینه ماهانه سنگین
                <br />
                🔹 موجیم → هزینه منطقی با امکانات بیشتر و ماندگار
              </li>
            </ul>

            <h3 className="text-xl md:text-2xl font-bold mb-4 text-gray-900 dark:text-white">
              چطور با اپ موجیم شروع کنم؟
            </h3>

            <ol className="space-y-4 text-sm md:text-base text-gray-700 dark:text-gray-200">
              <li>
                <span className="font-bold text-purple-500 ml-2">۱.</span>
                اپ موجیم را از کافه‌بازار نصب کن.
              </li>
              <li>
                <span className="font-bold text-purple-500 ml-2">۲.</span>
                با شماره موبایل‌ات وارد شو و هدف، سن، قد، وزن، سطح تمرین و تجهیزات
                را وارد کن.
              </li>
              <li>
                <span className="font-bold text-purple-500 ml-2">۳.</span>
                برنامه تمرین و تغذیه اختصاصی‌ات را دریافت کن—کاملاً مبتنی بر
                داده‌های شخصی خودت.
              </li>
              <li>
                <span className="font-bold text-purple-500 ml-2">۴.</span>
                برنامه را یک‌بار در حالت آنلاین باز کن؛ از این لحظه به بعد، تمام
                جزئیات تمرین و تغذیه در حالت{' '}
                <span className="font-semibold">آفلاین</span> هم در دسترس‌اند.
              </li>
              <li>
                <span className="font-bold text-purple-500 ml-2">۵.</span>
                روزبه‌روز پیشرفتت را ببین، از یادآورها کمک بگیر و قدم‌به‌قدم به
                هدفت نزدیک‌تر شو.
              </li>
            </ol>
          </div>
        </section>
      </main>

      {/* فوتر */}
      <footer className="bg-gray-200 dark:bg-[#0e1015] py-6 text-center text-xs text-gray-600 dark:text-gray-400 border-t border-gray-300 dark:border-gray-700">
        <p>
          © {new Date().getFullYear()} موجیم — اولین اپلیکیشن هوشمند برنامه‌ساز
          ایرانی
        </p>
      </footer>
    </div>
  );
}

function FeatureLine({ icon, text }) {
  return (
    <div className="flex items-center justify-end gap-2">
      {/* آیکن دقیقاً سمت راست */}
      <span className="text-green-400 text-base">{icon}</span>
      <span className="text-sm text-gray-800 dark:text-gray-100">{text}</span>
    </div>
  );
}

function MobileCard({ title, desc }) {
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 px-3 py-2 text-right">
      <p className="text-[11px] text-gray-300 mb-1 font-vazir">{title}</p>
      <p className="text-[10px] text-gray-400 leading-4">{desc}</p>
    </div>
  );
}

function FeatureCard({ title, body }) {
  return (
    <div className="rounded-2xl bg-gray-100 dark:bg-[#050816] border border-gray-200 dark:border-gray-700 p-4 text-right">
      <h3 className="font-bold mb-2 text-sm md:text-base text-gray-900 dark:text-white">
        {title}
      </h3>
      <p className="text-xs md:text-sm text-gray-600 dark:text-gray-300 leading-6">
        {body}
      </p>
    </div>
  );
}
